import { render } from "./CreateInstanceDialog.vue?vue&type=template&id=5264ef62&ts=true"
import script from "./CreateInstanceDialog.vue?vue&type=script&lang=ts"
export * from "./CreateInstanceDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__